import Vue from 'vue'
import VueI18n from 'vue-i18n'

Vue.use(VueI18n)

// 准备翻译文件
import zhCN from './zh.js'
import enUS from './en.js'
import idID from './id.js'

const messages = {
  'zh-CN': zhCN,
  'en-US': enUS,
  'id-ID': idID
}

// 从本地存储获取语言设置，默认跟随浏览器
const savedLang = localStorage.getItem('user_language')
const browserLang = navigator.language || 'zh-CN'
const defaultLang = ['zh-CN', 'en-US', 'id-ID'].includes(browserLang) 
  ? browserLang 
  : 'zh-CN'

const i18n = new VueI18n({
  locale: savedLang || defaultLang,
  fallbackLocale: 'zh-CN',
  messages
})

export default i18n


// WEBPACK FOOTER //
// ./src/lang/index.js